const dictOperationReason = {
  userRequested: 0,
  accountClosure: 1,
  branchTransfer: 2,
  fraud: 4,
  defaultOperation: 5,
  reconciliation: 6
};

module.exports = dictOperationReason;
